import React, {useRef} from 'react';
import {PublicMenuProvider} from "../contexts/PublicMenuContext";
import ErrorHandler from "../../common/errors/ErrorHandler";
import MetricsService from "../../common/services/MetricsService";
import Constants from "../../common/Constants";
import keys from '../utils/locResourcesKeys';
import {LocResourcesProvider} from '../../common/contexts/LocResourcesContext';
import PublicMenuComponent from "./PublicMenuComponent";
import {Domain, findSiteByDomain} from "@zooplus/commons-lang";
import {getLocale} from "../../common/utils/locale";

interface PublicMenuProps {
    siteDomain: Domain;
    selectedMenuItem: string;
    bpEnabled: boolean;
}

const PublicMenu = ({siteDomain, selectedMenuItem, bpEnabled}: PublicMenuProps): JSX.Element => {
    const metricServiceInstanceRef = useRef<MetricsService>(
      MetricsService.init(Constants.COMPONENT_NAME.PUBLIC_MENU, Constants.COMPONENT_LOCATION.PUBLIC_MENU, siteDomain)
    );
    const site = findSiteByDomain(siteDomain);
    return (
        <ErrorHandler
            metricsService={metricServiceInstanceRef.current}>
            <LocResourcesProvider metricsService={metricServiceInstanceRef.current} locale={getLocale(site)}
                                  keys={keys} siteId={site.id}>
                <PublicMenuProvider
                    metricsService={metricServiceInstanceRef.current}>
                  <PublicMenuComponent
                    bpEnabled={bpEnabled}
                    selectedMenuItem={selectedMenuItem}
                  />
                </PublicMenuProvider>
            </LocResourcesProvider>
        </ErrorHandler>
    )
}

export default React.memo(PublicMenu)
